// 设置 rem 函数
export function setRem() {
  const baseSize = 16;
  const scale = document.documentElement.clientWidth / 1440;
  // 设置页面根节点字体大小
  document.documentElement.style.fontSize =
    baseSize * Math.min(scale, 10) + "px";
}
// 初始化
setRem();
// 改变窗口大小时重新设置 rem
window.onresize = function () {
  setRem();
};
